import { hipNew } from '../api';
import ActionTypes from '../constants/ActionTypes';

export const subscribeToNewsletter = values => {
  return async dispatch => {
    try {
      // API expects form data
      const { from, fullname, email, postcode } = values;

      const formData = new FormData();
      formData.set('from', from);
      formData.set('fullname', fullname);
      formData.set('email', email);
      formData.set('postcode', postcode);

      await hipNew.post('/consumer/newsletter-signup-postcode', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      await dispatch({
        type: ActionTypes.NEWSLETTER_SUBSCRIPTION_SUCCESS,
        payload: null
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.NEWSLETTER_SUBSCRIPTION_ERROR,
        payload: null
      });
    }
  };
};
